import { useIsomorphicLayoutEffect } from '@yes.technology/react-toolkit'
import { useState } from 'react'

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState({
    windowWidth: typeof window === 'undefined' ? 0 : globalThis.innerWidth,
    windowHeight: typeof window === 'undefined' ? 0 : globalThis.innerHeight
  })

  useIsomorphicLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions({
        windowWidth: globalThis.innerWidth,
        windowHeight: globalThis.innerHeight
      })
    }

    globalThis.addEventListener('resize', handleResize)
    handleResize()
    return () => globalThis.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}
